import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-overlay" />
      <div className="hero-content">
        <div style={{ marginTop: "-80px" }}>
          <p className="hero-pen-gold">Ene!</p>
          <p className="hero-pen-black">O mametse</p>
          <h1 className="hero-title"><span className="hero-k">K</span>GUBETSWANA <span className="hero-fm">FM</span></h1>
          <div className="hero-record"></div>
          <p className="hero-love-text">...Ka lerato Leo</p>
          <p className="hero-tagline">
            <span className="hero-icon-circle"></span> Re Mona <span className="hero-lona">Le Lona</span>,<br />
            <span className="hero-icon-circle hero-icon-music"></span> Re Bina <span className="hero-lona">Le Lona</span>,<br />
            <span className="hero-icon-circle hero-icon-chat"></span> Re Bua <span className="hero-lona">Le Lona</span>.
          </p>

        </div>
      </div>
    </section>
  );
}
